import { createContext } from 'react';
import { createContextualCan } from '@casl/react';
import { AppAbility, defineAbilitiesFor } from './defineAbilities';

export const AbilityContext = createContext<AppAbility>(defineAbilitiesFor('student'));

export const Can = createContextualCan(AbilityContext.Consumer);
